import { useAtom } from '@reatom/npm-react'

import { trackingWalletsByAddressAtom } from '../atoms/reatom-tracking-wallets'

import type { Address } from '@root/entities/address/Address'

export const useTrackedWallet = (address: Address) => {
  const [maker] = useAtom(
    (ctx) => {
      const byAddress = ctx.spy(trackingWalletsByAddressAtom)
      return byAddress[address]
    },
    [address],
  )
  return maker
}

export const useTrackedWalletLabel = (address: Address) => {
  return useTrackedWallet(address)?.label || undefined
}
